import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '@shared/service';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  styleUrl: './toast-host.component.scss',
  imports: [CommonModule],
  templateUrl: './toast-host.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHostComponent {
  readonly toastSvc = inject(ToastService);

  iconFor(type: 'success' | 'error' | 'warning' | 'info'): string {
    switch (type) {
      case 'success': return '✓';
      case 'error':   return '✕';
      case 'warning': return '⚠';
      case 'info':    return 'ℹ';
    }
  }

  dismiss(id: number) {
    this.toastSvc.dismiss(id);
  }
}
